<div class="state-item">
  <span class="state-color" [style.backgroundColor]="color"></span>
  <span class="state-text">{{label}}</span>
</div>
